module.exports = __webpack_public_path__ + "static/media/18ECA18.a237e4ed.jpg";